/* eslint-disable react/prefer-stateless-function */
import React from 'react';

import styles from './checkBox.scss';

class CheckBox extends React.Component {
    render() {
        return (
            <div
                className={`${styles.checkBoxContainer} ${this.props.colClass ? this.props.colClass : ''} ${this.props.item.isSelected ? styles.selected : ''} ${this.props.disabled ? styles.disabled : ''}`}
                onClick={() => {
                    if (!this.props.disabled) {
                        this.props.onChanged(this.props.item);
                    }
                }}
            >
                <div className={`${styles.checkIcon} ${this.props.item.isSelected ? 'fas fa-check' : ''}`} />
                <div className={`${styles.label} get-rated-label`}>
                    {this.props.item.name}
                </div>
            </div>
        );
    }
}

export default CheckBox;
